export const routePaths = {
  main: '/',
  login: '/login',
  forgetPassword: '/forgetPassword',
  verificationCode: '/verificationCode',
  newPassword: '/newPassword',
  simulate: '/simulador-de-multas',
  home: '/home',
  functions: '/functions',
  demands: '/demands',
  filedDemands: '/filedDemands',
  newDemand: '/demands/new',
  editDemands: '/demands/edit/:id',
  terms: '/terms',
  users: '/users',
  newuser: '/users/new',
  editusers: '/users/edit/:id',
  budgetControl: '/budgetControl',
  evaluationProject: '/evaluation/project',
  evaluationProjectDetail: '/evaluation/project/:id',
  clientDemands: '/clientDemands',
  newClientDemands: '/clientDemands/new',
  editClientDemands: '/clientDemands/edit/:id',
  detailsClientDemands: '/clientDemands/details/:id',
  ropa: '/ropa',
  ropaDetails: '/ropa/:id',
  ali: '/ali',
  aliDetail: '/ali/:id',
  thirdPartyAssessment: '/TPA',
  thirdPartyAssessmentDetails: '/TPA/:id',
  myAvaliations: '/myAvaliations',
  dashBoard: '/dashboard',
  changePassword: '/changePassword',
  fineSimulator: '/fineSimulator',
  simulatedFines: '/simulatedFines',
  lawyerManagement: '/lawyerManagement',
};
